var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 508 508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "cutout-mask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.8,420.4v-45.6c0-7.2-5.6-12.8-12.8-12.8h-46V100.4c0-7.2,5.6-12.8,12.8-12.8h254 c7.2,0,12.8,5.6,12.8,12.8v307.2c0,7.2-5.6,12.8-12.8,12.8H172.8z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("circle", {
    style: {
      paintOrder: "fill",
      fillRule: "nonzero",
      fill: "#fff"
    },
    cx: 254,
    cy: 254,
    r: 254,
    mask: "url(#cutout-mask)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "matrix(1, 0, 0, 1, 235.068161, -25.511274)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -234.189987, 26.333487)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.2,
    y: 120.8,
    style: {
      fill: "#fff"
    },
    width: 229.6,
    height: 16.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.2,
    y: 158,
    style: {
      fill: "#fff"
    },
    width: 229.6,
    height: 16.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.2,
    y: 195.2,
    style: {
      fill: "#fff"
    },
    width: 229.6,
    height: 16.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.2,
    y: 232,
    style: {
      fill: "#fff"
    },
    width: 99.2,
    height: 16.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.2,
    y: 268.4,
    style: {
      fill: "#fff"
    },
    width: 99.2,
    height: 16.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.2,
    y: 304.4,
    style: {
      fill: "#fff"
    },
    width: 99.2,
    height: 16.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -332.57019, 77.124146)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M 454.79 238.666 C 457.59 235.866 457.59 231.866 454.79 229.066 C 452.79 227.066 452.39 224.266 453.19 221.866 C 454.79 218.266 452.79 214.266 449.59 213.066 C 447.19 211.866 445.59 209.466 445.59 206.666 C 445.59 203.066 442.39 199.866 438.79 199.866 C 435.99 199.866 433.59 198.266 432.39 195.866 C 430.79 192.266 427.19 190.666 423.59 192.266 C 421.19 193.466 417.99 192.666 416.39 190.666 C 413.59 187.866 409.59 187.866 406.79 190.666 C 404.79 192.666 401.99 193.066 399.59 192.266 C 395.99 190.666 391.99 192.666 390.79 195.866 C 389.59 198.266 387.19 199.866 384.39 199.866 C 380.79 199.866 377.59 203.066 377.59 206.666 C 377.59 209.466 375.99 211.866 373.59 213.066 C 369.99 214.666 368.39 218.266 369.99 221.866 C 371.19 224.266 370.39 227.466 368.39 229.066 C 365.59 231.866 365.59 235.866 368.39 238.666 C 370.39 240.666 370.79 243.466 369.99 245.866 C 368.39 249.466 370.39 253.466 373.59 254.666 C 375.99 255.866 377.59 258.266 377.59 261.066 C 377.59 264.666 380.79 267.866 384.39 267.866 C 387.19 267.866 389.59 269.466 390.79 271.866 C 392.39 275.466 395.99 277.066 399.59 275.466 C 401.99 274.266 405.19 275.066 406.79 277.066 C 409.59 279.866 413.59 279.866 416.39 277.066 C 418.39 275.066 421.19 274.666 423.59 275.466 C 427.19 277.066 431.19 275.066 432.39 271.866 C 433.59 269.466 435.99 267.866 438.79 267.866 C 442.39 267.866 445.59 264.666 445.59 261.066 C 445.59 258.266 447.19 255.866 449.59 254.666 C 453.19 253.066 454.79 249.466 453.19 245.866 C 452.39 243.466 452.79 240.666 454.79 238.666 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -34.622444, -43.733612)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD05B"
    },
    cx: 445.812,
    cy: 277.6,
    r: 34.4
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -367.326141, 33.690449)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "445.812 286.8 425.812 286.8 425.812 371.6 445.812 351.6 466.212 371.6 466.212 286.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff"
    },
    cx: 445.812,
    cy: 277.6,
    r: 30
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificates);
export default __webpack_public_path__ + "static/media/certificates.b721dcb5dd757e5dbb795a4430526cf9.svg";
export { ForwardRef as ReactComponent };